import { Component, ElementRef, EventEmitter, Input, NgZone, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import * as moment from 'moment';
import { VinoItem } from 'src/app/_classi/VinoItem';
import { MessageServiceService } from 'src/app/_servizi/message-service.service';

@Component({
  selector: 'app-dettaglio-vino',
  templateUrl: './dettaglio-vino.component.html',
  styleUrls: ['./dettaglio-vino.component.css']
})
export class DettaglioVinoComponent implements OnInit, OnChanges {

  @Input() vino: VinoItem;
  @Input() codiceForm: any;
  @Input() linguaCorrente: any;
  @Input() canBack: any;
  @Input() idx: any;
  @Input() vinoSelezionato: any;
  @Input() fromBase: boolean;
  @Input() stepVino: boolean;

  specificheDef = [];

  @Output() goBack = new EventEmitter<any>();
  @Output() selezionaVino = new EventEmitter<any>();

  constructor(
    private messageService: MessageServiceService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    const specifiche = this.vino.getSpecifiche(this.vino);
    this.specificheDef = specifiche.filter(specifica => specifica.data || specifica.data !== '');
    this.vino.specificheList = this.specificheDef;
  }

  ngOnInit(): void {
  }

  emitSelezionaVino(vino): void {
    const obj = {
      vino: vino,
      idx: this.vino.id
    }
    this.selezionaVino.emit(obj);
  }

  tornaIndietro() {
    const tipo = this.fromBase ? 'base' : 'colonne'
    this.goBack.emit(tipo);
  }

  scrollTO(target, time) {
    setTimeout(() => {
      document.getElementById(target).scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    }, time);
  }
}
